import React from "react";
import styled from "styled-components";

const ComponentWrapper = styled.div`
	padding: 1rem;
	border-radius: 8px;
	width: max-content;
`;

const Heading = styled.h2`
	font-size: 16px;
	margin-bottom: 0.5rem;
    color: #4b5563;
`;

const Value = styled.div`
	font-size: 14px;
    font-weight: 600;
	color: #000;
`;

const Container = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
    padding: 0.5rem;
    background: ${({ isErrored }) => isErrored ? "rgba(244, 66, 54, 0.2)" : "#f3f4f6"};
    align-items: center;
    border-radius: 0.5rem;
`;

const ContentComponent = ({ title, value, key }) => {
	return (
		<ComponentWrapper key={key} >
			<Heading>{title}</Heading>
			<Value>{ value ?? "-"}</Value>
		</ComponentWrapper>
	);
};

const ContentContainer = ({ children, key, isErrored = false }) => {
	return (
		<Container isErrored={isErrored} key={key} >
            {children}
		</Container>
	);
};

export { ContentComponent, ContentContainer };
